import { NotificationManager } from 'react-notifications';

export const showNotification = message => {
  NotificationManager.error(message, null, 3000);
};



// WEBPACK FOOTER //
// ./src/helpers/notification.js